<template>
  <van-popup v-model="taskPopup" class="popup task-popup" :close-on-click-overlay="false" @click-overlay="close">
    <div class="popup-wrap">
      <div class="popup-title">完成任务获取游戏次数</div>
      <div class="popup-box">
        <task @jumpShare="jumpShare"></task>
      </div>
      <div  class="popup-close"  @click="close"></div>
    </div>
  </van-popup>

</template>
<script>
import { jumpPage } from '../../mixins/functions'
import task from './task-list'
export default {
  name: 'task-popup',
  data() {
    return {
      taskListLength:1,
      taskPopup:false
    }
  },
  methods: {
    openTaskPopup(){
      this.taskPopup = true
    },
    close(){
      this.$emit('closePopup')
      this.$storejs.set(`${this.$key}isTask`,true)
      this.taskPopup = false
    },
    jumpShare(){
      this.$emit('jumpShare')
    }
  },
  components: {
      task
  }
}
</script>

<style lang="scss" scoped>
.popup-title{
  text-align: center;
  color:#fcd127;
  font-size: 34px;
  padding: 20px 0;
}
.more{
  text-align: center;
  color: #00b5ff;
  padding: 10px 0;
  border-top:1px solid #fff4d0;
}
.list {
    width: 690px;
    margin:0 auto;
    background: #fff;
    padding: 0 20px 0;
    border:4px solid #fe5e5c;
    box-sizing: border-box;
    border-radius: 25px;
    .item {
        display: flex;
        align-items: center;
        padding-bottom:20px;
        .name {
            flex: 1;
            line-height: 1.4;
            padding-right: 10px;
            color: #333;
            display: flex;
            align-items: center;
        }
        .btn {
            width: 120px;
            height: 50px;
            line-height: 50px;
            color: #fff;
            border-radius: 25px;
            text-align: center;
            background:  linear-gradient(#fcd127, #fc9827);
            &.active {
                border: 2px solid #888888;
                color: #fff;
                background: linear-gradient(to right, #888888, #8c8c8c);
            }
        }
    }
}
</style>
